<template>
  <v-container>
    <portal to="content-before">
      <OrsInnerToolbar
        title="Ordem de serviço"
      />
    </portal>
    <v-btn
      text
      x-large
      color="primary"
      class="font-weight-bold"
      :to="{name: 'AlarmsList'}"
    >
      <v-icon left>
        mdi-chevron-left
      </v-icon>
      Voltar
    </v-btn>
    <v-row
      v-if="isLoading"
      justify="center"
      class="mt-8"
    >
      <v-progress-circular indeterminate />
    </v-row>
    <v-row
      v-else-if="noResults || serviceOrders === null"
      justify="center"
      class="mt-8"
    >
      <h3>
        Não existem ordens de serviço
      </h3>
    </v-row>
    <OrsTimeline
      v-else
      :dense="$vuetify.breakpoint.smAndDown"
    >
      <OrsTimelineItem
        v-for="(order, orderIdx) in serviceOrders"
        :key="orderIdx"
        :color="getOrderColor(order)"
      >
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-input label="OS">
              {{ order.idOrdem }}
            </v-input>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-input label="Abertura">
              {{ order.abertura }}
            </v-input>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-input label="Fechamento">
              {{ order.fechamento || '--' }}
            </v-input>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-input
              label="Situação"
              :class="`${getOrderColor(order)}--text`"
            >
              {{ getOrderSituation(order) }}
            </v-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-input label="Descrição">
              {{ order.defeito }}
            </v-input>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <v-input
              v-if="order.executado"
              label="Executado"
            >
              {{ order.executado }}
            </v-input>
          </v-col>
        </v-row> -->
      </OrsTimelineItem>
    </OrsTimeline>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import OrsInnerToolbar from '@/components/OrsInnerToolbar.vue';
import OrsTimeline from '../components/OrsTimeline.vue';
import OrsTimelineItem from '@/components/OrsTimelineItem.vue';

const alarmsList = createNamespacedHelpers('views/alarmsList');

export default {
  name: 'AlarmsServiceOrder',
  components: {
    OrsInnerToolbar,
    OrsTimeline,
    OrsTimelineItem,
  },
  props: {
    alarmIdx: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...alarmsList.mapGetters([
      'isLoading',
      'noResults',
    ]),
    ...alarmsList.mapState([
      'alarms',
      'serviceOrders',
    ]),
  },
  watch: {
    alarms() {
      // FIXME: not so beaulty but works, loadContact when parent alarms changes
      this.loadServiceOrder(this.alarmIdx);
    },
  },
  methods: {
    ...alarmsList.mapActions([
      'loadServiceOrder',
    ]),
    getOrderColor(order) {
      const map = {
        1: 'teal',
        0: 'primary',
      };
      return map[Number(order.fechado)];
    },
    getOrderSituation(order) {
      const map = {
        1: 'Fechada',
        0: 'Aberta',
      };
      return map[Number(order.fechado)] || 'N/A';
    },
  },
};
</script>
